import { AlertTriangle, CheckCircle2, TrendingDown, FileCheck } from 'lucide-react';
import { AnimatedSection, AnimatedItem, AnimatedCard } from '@/components/animations';

export function TypicalCaseSection() {
  return (
    <section className="py-16 md:py-24 border-t border-border bg-primary/5">
      <div className="container">
        <AnimatedSection className="max-w-4xl mx-auto" stagger>
          <AnimatedItem className="text-center mb-10">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 text-primary text-sm font-medium mb-6">
              <FileCheck className="w-4 h-4" />
              Caso Real
            </div>
            <h2 className="text-3xl md:text-4xl font-bold">Um caso típico</h2>
          </AnimatedItem>

          <AnimatedCard className="p-6 md:p-8 rounded-2xl bg-card border border-border shadow-sm">
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-destructive/10 flex items-center justify-center shrink-0">
                  <AlertTriangle className="w-5 h-5 text-destructive" />
                </div>
                <div>
                  <p className="text-sm text-muted-foreground mb-1">
                    Proposta apresentada pelo operador
                  </p>
                  <p className="text-2xl font-bold text-foreground">
                    Modernização total — €62.000
                  </p>
                </div>
              </div>

              <div className="border-l-4 border-primary pl-4 py-2 bg-primary/5 rounded-r-lg">
                <p className="text-sm font-medium text-primary mb-2">
                  Análise ElevAdvisor:
                </p>
                <ul className="space-y-2 text-sm text-foreground">
                  <li className="flex items-start gap-2">
                    <CheckCircle2 className="w-4 h-4 text-primary shrink-0 mt-0.5" />
                    <span>
                      Apenas <strong>2 não conformidades críticas</strong>{' '}
                      segundo EN 81
                    </span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle2 className="w-4 h-4 text-primary shrink-0 mt-0.5" />
                    <span>
                      Restantes itens classificados como{' '}
                      <strong>recomendáveis, não obrigatórios</strong>
                    </span>
                  </li>
                </ul>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-green-500/10 flex items-center justify-center shrink-0">
                  <TrendingDown className="w-5 h-5 text-green-600" />
                </div>
                <div>
                  <p className="text-sm text-muted-foreground mb-1">
                    Decisão final
                  </p>
                  <p className="text-lg font-semibold text-foreground">
                    Faseamento técnico — redução de 40% no investimento inicial
                    e mitigação de risco jurídico
                  </p>
                </div>
              </div>

              <p className="text-xs text-muted-foreground italic border-t border-border pt-4">
                Caso anonimizado. Sem promessa comercial. Cada situação é única
                e requer análise específica.
              </p>
            </div>
          </AnimatedCard>
        </AnimatedSection>
      </div>
    </section>
  );
}
